import React from 'react'

import { setloftUnavailableModalOpenModalOpen, setSelectedToolbarTabIndex } from '../../store/ui/uiSlice'
import Modal from '../Modal/Modal'
import Heading from '../Heading/Heading'

import * as commonStyles from '../styles'
import * as styles from './styles'
import { useAppDispatch, useAppSelector } from '../../hooks'

const Styled = {
  ...commonStyles,
  ...styles,
}

const LoftUnavailableModal: React.FC = () => {
  const { loftUnavailableModalOpen } = useAppSelector((state) => state.ui) || {}
  const { content } = useAppSelector((state) => state.init) || {}
  const dispatch = useAppDispatch()

  const roofTabIndex = 2

  const closeLoftUnavailableModal = (): void => {
    dispatch(setSelectedToolbarTabIndex(roofTabIndex))
    dispatch(setloftUnavailableModalOpenModalOpen(false))
  }

  return (
    <Modal
      isOpen={loftUnavailableModalOpen}
      onRequestClose={closeLoftUnavailableModal}
      contentLabel={content?.modals?.backPrompt?.title} // only for screenreaders
    >
      <Styled.ModalBackPrompt>
        <Heading level={2}>{content?.modals?.loftUnavailable?.promptedFromRoofTab?.title}</Heading>
        <p>{content?.modals?.loftUnavailable?.promptedFromRoofTab?.information}</p>
        <Styled.Button className="button-secondary" onClick={closeLoftUnavailableModal}>
          {content?.modals?.loftUnavailable?.cancel}
        </Styled.Button>
        <Styled.Button className="button-primary" onClick={closeLoftUnavailableModal}>
          {content?.modals?.loftUnavailable?.ok}
        </Styled.Button>
      </Styled.ModalBackPrompt>
    </Modal>
  )
}

export default LoftUnavailableModal
